import React from "react";
import { Assets } from "../../assets";

export const ButtonSecondary = ({
	name = "",
	action = () => {
		console.log("back");
	},
}) => {
	return (
		<div className="flex gap-1 items-center justify-center bg-grayButton py-2 pl-2 pr-3 rounded-lg cursor-pointer" onClick={action}>
			<img className="h-[15px] w-[15px]" src={Assets.icon.back} alt="back" />
			<div>
				<span className="mediumFont text-white text-[14px]">{name}</span>
			</div>
		</div>
	);
};
